export const VALUE_TOOLTIP_KEYWORDS = [
  'Value:', // en-US, en-GB, en-AU, en-CA, en-DE, en-IN, en-NZ
  'Wert:', // de-DE, de-CH
  'Valeur', // fr-FR, fr-CA
  'Valor:', // es-ES, es-US, es-MX, pt-BR, pt-PT
  'Valore:', // it-IT
  'Waarde:', // nl-NL
  'Værdi:', // da-DK
  'Arvo:', // fi-FI
  'Verdi:', // nb-NO
  'Värde:', // sv-SE
  'Значение:', // ru-RU
  '値:', // ja-JP
  '值:', // zh-CN, zh-HANT
  '值：', // zh-CN, zh-HANT
  '값:', // ko-KR
];

export const CURRENT_VALUE_TOOLTIP_KEYWORDS = [
  'Current value:', // en-US, en-GB, en-AU, en-CA, en-DE, en-IN, en-NZ
  'Aktueller Wert:', // de-DE, de-CH
  'Valeur actuelle:', // fr-FR, fr-CA
  'Valor actual:', // es-ES, es-US, es-MX
  'Valor atual:', // pt-BR, pt-PT
  'Valore attuale:', // it-IT
  'Huidige waarde:', // nl-NL
  'Aktuel værdi:', // da-DK
  'Nykyinen arvo:', // fi-FI
  'Nåværende verdi:', // nb-NO
  'Aktuellt värde:', // sv-SE
  'Текущее значение:', // ru-RU
  '現在の値:', // ja-JP
  '当前值:', // zh-CN, zh-HANT
  '当前值：', // zh-CN, zh-HANT
  '현재 값:', // ko-KR
];
